import React, { useState } from 'react';

import { connect } from 'react-redux';

import { isEmpty } from 'lodash';

import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';

import * as AttributeManagementActions from '../../../actions/attributeManagementActions';
import { enqueueSnackbar } from '../../../actions/applicationMessageActions';

import * as classes from './ButtonPanel.module.css';

const ButtonPanel = ({
    activeNavCompany,
    attributeValues,
    enqueueSnackbar,
    fetchAMClients,
    fetchCustomAttributes,
    items,
    setItems,
    selectedAttribute,
    selectedAttributeValue,
    selectedEntity,
    selectedState,
    sources,
    tabValue,
    updateAMClient,
    updateAttributeValues,
    ...props
}) => {

    const [isLoading, setIsLoading] = useState(false);

    const handleSave = async () => {
        if (tabValue === 0) {
            setIsLoading(true);
            await updateAttributeValues(activeNavCompany.id, items, selectedEntity.id, selectedAttribute.id);
            // reload the attributes so they are available to use right away
            fetchCustomAttributes();
            setIsLoading(false);
        } else if (tabValue === 1) {
            if (isEmpty(selectedAttributeValue)) {
                enqueueSnackbar('Select a value to be applied before saving.', 'error');
                return;
            }
            setIsLoading(true);
            const entitiesToUpdated = [...selectedState];

            for (const item of entitiesToUpdated) {
                item.customAttributes = {};
                const source = sources.find(item => item.name === 'K2A Core');
                item.customAttributes.customAttributeValuePairs = [
                    {
                        customAvp:
                            { attributeId: selectedAttribute.id, avpId: selectedAttributeValue.id },
                        sourceAvp:
                            { avpId: source.id, attributeId: source.attributeId }
                    }
                ];
                item.businessTypeId = item.businessType.id;
                await updateAMClient(item);
            }

            if (selectedEntity.name === 'Client') {
                await fetchAMClients(activeNavCompany.id);
                enqueueSnackbar('Attribute values assigned successfully.', 'success');
            }

            setIsLoading(false);
        }
    };

    return (
        <React.Fragment>
            <BobCancelButton
                className={classes.CancelButton}
                label={'Cancel'}
            />
            <BobConfirmButton
                className={classes.Buttons}
                onClick={() => handleSave()}
                disabled={isEmpty(selectedEntity) || isEmpty(selectedAttribute)}
                label={'Save & Close'}
                isLoading={isLoading}
                iconSize={15}
            />
            <BobConfirmButton
                className={classes.Buttons}
                label={'Preview Results'}
                iconSize={15}
            />
        </React.Fragment>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:       state.bob.activeNavCompany,
        attributeValues:        state.attributeManagement.attributeValues,
        selectedAttributeValue: state.attributeManagement.selectedAttributeValue,
        selectedState:          state.attributeManagement.selectedState,
        sources:                state.attributeManagement.sources
    };
};

const mapDispatchToProps = {
    enqueueSnackbar,
    ...AttributeManagementActions
};

export default connect(mapStateToProps, mapDispatchToProps)(ButtonPanel);
